export default __webpack_public_path__ + "locales/ar-SA/Common.json?hash=ca191537be1f6b51d57a2bbb98049ba0";